import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer } from '@angular/platform-browser';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { HelperService } from '../../../services';
import { MyTeamsService } from '../../../services/my-teams.service';

@Component({
  selector: 'app-read-received-message',
  templateUrl: './read-received-message.component.html',
  styleUrls: ['./read-received-message.component.css']
})
export class ReadReceivedMessageComponent {
  public Editor = ClassicEditor;
  public userID;
  public isReply: boolean;

  @Input() canReply: boolean;
  @Input() coachList: any[];
  @Input() message: any;
  @Input() isSentMessage: boolean;
  form: FormGroup;
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() refreshPage: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private service: MyTeamsService,
    private notificationsService: NotificationsService,
    private helperService: HelperService,
    private ds: DomSanitizer
  ) {
    this.form = this.fb.group({
      //TextTitle: [null, Validators.required],
      TextNote: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.userID = localStorage.getItem('userId');
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      Message: [null, Validators.required]
    });
  }

  setMessageBody(message) {
    return this.ds.bypassSecurityTrustHtml(message.messagebody);
  }

  onClose(event: Event) {
    event.preventDefault();
    this.isReply = false;
    this.close.emit(false);
    this.resetForm();
  }

  onReply() {
    this.isReply = true;
  }

  onSubmit(event) {
    console.log(this.message);
    event.preventDefault();
    this.form.disable();

    event.target.innerHTML = 'Sending <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;

    this.coachList = [{ UserID: this.message.sender, Email: this.message.senderEmail.toString() }];

    this.service.sendReply({
      SenderID: +this.userID,
      CollegeCoachList: this.coachList,
      MessageBody: this.form.value.Message,
      Subject: this.message.subject
    }).subscribe(
      () => {
        this.emailSentSuccessfully(event);
      },
      () => {
        this.errorWhileSendingEmail(event);
      }
    );
  }

  emailSentSuccessfully(event) {
    event.target.disabled = false;
    event.target.innerHTML = 'Send';
    this.helperService.alertMessage("success", "HIGH FIVE!", "Sent Email Successfully.");
    this.resetForm();
    this.close.emit(false);
    this.refreshPage.emit(true);
  }

  errorWhileSendingEmail(event) {
    event.target.disabled = false;
    event.target.innerHTML = 'Send';
    this.helperService.alertMessage("error", "HOUSTON!", "Email not sent.");
    this.form.enable();
  }

  resetForm() {
    this.form.enable();
    this.form.patchValue({
      //TextTitle: null,
      TextNote: null
    });
  }

  setLogo(url) {
    return this.helperService.setClubLogo(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/read-received-message/read-received-message.component.ts